// Class: starling.utils.StringUtil

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $hxEnums = require("./../../hxEnums_stub").default;
var $import = require("./../../import_stub").default;
function EReg() {return require("./../../EReg");}
function Std() {return require("./../../Std");}
function HxOverrides() {return require("./../../HxOverrides");}

// Constructor

var StringUtil = function(){}

// Meta

StringUtil.__name__ = "starling.utils.StringUtil";
StringUtil.__isInterface__ = false;
StringUtil.prototype = {
	
};
StringUtil.prototype.__class__ = StringUtil.prototype.constructor = $hxClasses["starling.utils.StringUtil"] = StringUtil;

// Init



// Statics

StringUtil.format = function(format,args) {
	var _g = 0;
	var _g1 = args.length;
	while(_g < _g1) {
		var i = _g++;
		var r = new (EReg().default)("\\{" + i + "\\}","g");
		format = r.replace(format,(Std().default).string(args[i]));
	}
	return format;
}
StringUtil.clean = function(string) {
	return (HxOverrides().default).substr("_" + string,1,null);
}
StringUtil.trimStart = function(string) {
	var pos = 0;
	var length = string.length;
	while(pos < length) {
		if((HxOverrides().default).cca(string,pos) > 32) {
			break;
		}
		++pos;
	}
	return string.substring(pos,length);
}
StringUtil.trimEnd = function(string) {
	var pos = string.length - 1;
	while(pos >= 0) {
		if((HxOverrides().default).cca(string,pos) > 32) {
			break;
		}
		--pos;
	}
	return string.substring(0,pos + 1);
}
StringUtil.trim = function(string) {
	var length = string.length;
	var startPos = 0;
	while(startPos < length) {
		if((HxOverrides().default).cca(string,startPos) > 32) {
			break;
		}
		++startPos;
	}
	var endPos = string.length - 1;
	while(endPos >= startPos) {
		if((HxOverrides().default).cca(string,endPos) > 32) {
			break;
		}
		--endPos;
	}
	return string.substring(startPos,endPos + 1);
}
StringUtil.parseBoolean = function(value) {
	if(!(value == "true" || value == "TRUE" || value == "True")) {
		return value == "1";
	} else {
		return true;
	}
}


// Export

exports.default = StringUtil;